import { createEntityAdapter, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from 'axios';
import { server } from "../staticData/staticData";
import * as Sentry from "@sentry/react";
const runAdapter=createEntityAdapter();
const initialState=runAdapter.getInitialState({});
const serverURL=server
export const getListRun=createAsyncThunk('run/getListRun', async ({day,driverId, site})=>{
     const config={
        headers: {'driverId': `${driverId}`}
    }
    try {
        const response=await axios.get(serverURL+"drivertempcheck/run?deliveryDay="+day+"&site="+site,config);
        return response.data;
    } catch (error) {
        Sentry.captureException(error)
        Sentry.captureMessage("Error getListRun, driverId: "+driverId+", site: "+site)
    }
})
const runSlice=createSlice({
    name:'run',
    initialState,
    reducers:{
        resetRunState:(state)=>state=initialState
    },
    extraReducers:(builder)=>{
        builder.addCase(getListRun.fulfilled,(state, action)=>{
            state.entities.runList=action.payload.sort((a,b)=>a.runName.localeCompare(b.runName))
            state.status="success"
        })
        builder.addCase(getListRun.pending,(state, action)=>{
            state.status="pending"
        })
        builder.addCase(getListRun.rejected,(state, action)=>{
            state.status="idle"
        })
    }
})
export default runSlice.reducer;
export const {resetRunState}=runSlice.actions;